import { QueryKey, useQuery, useQueryClient } from '@tanstack/react-query'
import { tierEligibilitiesByShiftIdKey } from './keys'
import { getTierEligibilitiesByShiftId } from 'api/shifts/getTierEligibilitiesByShiftId'
import { AxiosError } from 'axios'
import { TierEligibilityStats } from 'pages/Shifts/ShiftDetail/types'

export const useTierEligibilitiesByShiftIdQuery = (shiftId: number) => {
  return useQuery<
    TierEligibilityStats,
    AxiosError,
    TierEligibilityStats,
    QueryKey
  >({
    queryKey: tierEligibilitiesByShiftIdKey(shiftId),
    queryFn: () => getTierEligibilitiesByShiftId(shiftId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: (failureCount, error) => {
      if (!error || !error.response || failureCount >= 2) {
        return false
      }

      const status = error.response.status
      const retryStatusCodes = [408, 429, 500, 502, 503, 504]

      const shouldRetry = retryStatusCodes.includes(status)
      return shouldRetry
    },
  })
}

export const usePrefetchTierEligibilitiesByShiftIdQuery = (shiftId: number) => {
  const queryClient = useQueryClient()
  return () => {
    queryClient.prefetchQuery({
      queryKey: tierEligibilitiesByShiftIdKey(shiftId),
    })
  }
}
